import { Theater } from '@cinemark/content-api-client';

export const formatTheaterAddress = (theater: Theater): string => {
  const parts: string[] = [];

  if (theater.address1) {
    parts.push(theater.address1);
  }

  if (theater.address2) {
    parts.push(theater.address2);
  }

  const cityStateZip: string[] = [];

  if (theater.city) {
    cityStateZip.push(theater.city);
  }

  if (theater.state) {
    cityStateZip.push(theater.state);
  }

  if (theater.zipcode) {
    cityStateZip.push(theater.zipcode);
  }

  if (cityStateZip.length > 0) {
    parts.push(cityStateZip.join(' '));
  }

  return parts.join(', ');
};
